var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconVip({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 13,
    height: 13,
    rx: 6.5,
    fill: "#ED9082",
    stroke: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.625 9.72222H11.2778V10.5H2.625V9.72222ZM6.51875 5.44444H7.38403V8.55556H6.51875V5.44444ZM5.20569 5.44444H6.12505L4.83319 8.54156H3.96791L2.67605 5.44444H3.59541L4.40055 7.43283L5.20569 5.44444ZM9.11458 7.77778V8.55556H8.24931V5.44444H9.97986C10.3241 5.44444 10.6542 5.56736 10.8976 5.78615C11.141 6.00495 11.2778 6.30169 11.2778 6.61111C11.2778 6.92053 11.141 7.21728 10.8976 7.43607C10.6542 7.65486 10.3241 7.77778 9.97986 7.77778H9.11458ZM9.11458 6.22222V7H9.97986C10.0946 7 10.2046 6.95903 10.2858 6.8861C10.3669 6.81317 10.4125 6.71425 10.4125 6.61111C10.4125 6.50797 10.3669 6.40906 10.2858 6.33613C10.2046 6.26319 10.0946 6.22222 9.97986 6.22222H9.11458ZM2.625 3.5H11.2778V4.27778H2.625V3.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVip);
export default __webpack_public_path__ + "static/media/icon-vip.430f45a9d3e6963d92d06feee3407de0.svg";
export { ForwardRef as ReactComponent };